import Model from './Model'

export default class OptionValue extends Model {
  resource() {
    return 'optionValues'
  }
}
